import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';
import { useAuthStore } from '../../../stores/authStore';
import { CardNB, ButtonNB, IconNB } from '../../../components/ui-nb';
import { error as logError } from '../../../lib/logger';
import { getErrorMessage } from '../../../lib/errors';

interface Branch {
  id: string;
  name: string;
  address: string;
  phone: string;
  schedule_start: string;
  schedule_end: string;
}

export default function BranchList() {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [loading, setLoading] = useState(true);
  const organizationId = useAuthStore(s => s.user?.organizationId);

  useEffect(() => {
    if (!organizationId) return;
    async function fetchBranches() {
      try {
        const { data, error } = await supabase
          .from('branches')
          .select('*')
          .eq('organization_id', organizationId);
        if (error) throw error;
        setBranches(data ?? []);
      } catch (err) {
        logError('Error fetching branches', { error: getErrorMessage(err) });
      } finally {
        setLoading(false);
      }
    }
    fetchBranches();
  }, [organizationId]);

  return (
    <>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-bold text-nb-black">
          Branches
        </h1>
        {loading && <span className="text-nb-text-muted text-sm">Loading...</span>}
        <Link to="/en/admin/branches/new">
          <ButtonNB variant="primary" size="sm">
            <IconNB name="plus" size={16} />
            New Branch
          </ButtonNB>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {branches.map((branch) => (
          <CardNB key={branch.id} variant="interactive" className="p-6">
            <h2 className="text-lg font-nb font-bold text-nb-black mb-1">
              {branch.name}
            </h2>
            <p className="text-nb-text-muted text-sm mb-4">{branch.address}</p>

            <div className="flex flex-col gap-3 mb-6">
              <div className="flex justify-between items-center">
                <span className="text-nb-text-secondary text-sm">Address</span>
                <span className="font-nb font-medium text-nb-black">
                  {branch.address}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-nb-text-secondary text-sm">Phone</span>
                <span className="font-nb font-medium text-nb-black">
                  {branch.phone}
                </span>
              </div>
            </div>

            <Link to={`/en/admin/branches/${branch.id}`} className="block w-full">
              <ButtonNB variant="primary" size="sm" className="w-full">
                View
              </ButtonNB>
            </Link>
          </CardNB>
        ))}
      </div>
    </>
  );
}